import { storage } from '../../utils/storage';

export const DEVICEKEY: string = `DEVICEKEY`;

export const initialState = {
    device: storage.get(DEVICEKEY, ''),
}